import DButton from "discourse/ui-kit/d-button";

const PostMenuCopyLinkButton = <template>
  <DButton
    class="post-action-menu__copy-link"
    ...attributes
    @action={{@buttonActions.copyLink}}
    @icon="link"
    @label={{if @showLabel "post.controls.copy_action"}}
    @title="post.controls.copy_title"
    @ariaLabel="post.controls.copy_title"
  />
</template>;

export default PostMenuCopyLinkButton;
